import { createSlice } from '@reduxjs/toolkit'
import { AuthenticationState } from './types'

export const initialAuthenticationState: AuthenticationState = {
  authenticated: false,
  lastValidityCheck: null
}

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: initialAuthenticationState,
  reducers: {
    setAuthenticated: (state, action: { payload: boolean }) => {
      // Clear user data on sign out
      if (state.authenticated && !action.payload) {
        localStorage.clear()
      }

      state.authenticated = action.payload
      if (action.payload) {
        state.lastValidityCheck = Date.now()
      }
    }
  }
})

export const reducer = authenticationSlice.reducer

export const { setAuthenticated } = authenticationSlice.actions
